// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__22pOn","title":"InfoRow_title__3jVdV"};